import { useCallback, useState } from 'react';

import { useEffectOnce } from '@core/js/hooks/useEffectOnce';

export const useHiddenDomElement = ({ isReady }: { isReady: boolean }) => {
    const [isInDom, setIsInDom] = useState(false);
    const [isShowed, setIsShowed] = useState(false);

    const fnIsReady = useCallback(() => isReady, [isReady]);

    useEffectOnce(() => {
        setIsInDom(true);

        setTimeout(() => {
            setIsShowed(true);
        }, 0);
    }, [isReady], fnIsReady);

    return {
        isInDom,
        isShowed
    };
};
